import { OTHER_FAMILY_CARGO_TYPES, TCargoQuantityTotals, TCargoRow } from '@types';

/* Raw totals across a shipment's cargo rows - Bundle/Skid/Other rows sum into qty, every other row into
   spaces, and items counts every piece (1 bundle + 3 pallets = 4). Callers format these into their own
   screen's text. */
export const getCargoQuantityTotals = (rows: TCargoRow[]): TCargoQuantityTotals => {
	return rows.reduce((totals, row) => {
		const isQuantityRow = OTHER_FAMILY_CARGO_TYPES.includes(row.type);
		return {
			qty: totals.qty + (isQuantityRow ? row.qty : 0),
			spaces: totals.spaces + (isQuantityRow ? 0 : row.qty),
			items: totals.items + row.items,
			cubic: totals.cubic + row.cubic,
			weight: totals.weight + row.weight,
		};
	}, {
		qty: 0, spaces: 0, items: 0, cubic: 0, weight: 0
	});
};
